import router from '~/router';
import store from '~/store';
import { loadUser } from '~/services/UserService';

let initialized = false;

router.beforeEach(async (to, _, next) => {
  if (!initialized) {
    initialized = true;
    await loadUser();
  }

  const { authenticated } = store.getters;
  if (authenticated) {
    next();
    return;
  }

  const { anonymous } = to.meta || {};
  if (anonymous) {
    next();
    return;
  }

  next(`/aboutUs`);
});
